<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-container class="com-mb-graph pa-0" ref="graphBox">
        <v-row class="com-mb-card-header">
          <span class="com-mb-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="white" @click="$emit('close')">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-row class="com-mb-card-contents">
          <v-col>
            <v-row class="tm-mb-graph-select-box" no-gutters>
              <div class="px-2">{{ text.leftGraph }}</div>
              <div v-for="(item, idx) in graph" :key="'left' + idx">
                <v-btn
                  depressed
                  x-small
                  class="ml-1"
                  color="success"
                  width="60px"
                  :outlined="!(viewLeft == item.code)"
                  @click="viewLeft = item.code"
                  >{{ item.name }}</v-btn
                >
              </div>
            </v-row>
            <v-row class="tm-mb-graph-select-box" no-gutters>
              <div class="px-2">{{ text.rightGraph }}</div>
              <div v-for="(item, idx) in graph" :key="'left' + idx">
                <v-btn
                  depressed
                  x-small
                  class="ml-1"
                  color="success"
                  width="60px"
                  :outlined="!(viewRight == item.code)"
                  @click="viewRight = item.code"
                  >{{ item.name }}</v-btn
                >
              </div>
            </v-row>
            <v-row class="ml-3 my-1">
              <tm-wtrQual-graph
                :width="width"
                :height="height"
                :left="viewLeft"
                :right="viewRight"
                :isExpansion="graphSwitch.selectDisp"
                :isLegend="graphSwitch.isLegendDisp"
              ></tm-wtrQual-graph>
            </v-row>
            <v-row class="tm-mb-graph-select-box pa-1" no-gutters>
              <v-spacer></v-spacer>
              <v-btn
                tile
                depressed
                x-small
                color="success"
                width="50px"
                :outlined="graphSwitch.selectDisp === true"
                @click="graphSwitch.selectDisp = false"
                >{{ btn.zoomout }}</v-btn
              >
              <v-btn
                tile
                depressed
                x-small
                color="success"
                width="50px"
                :outlined="graphSwitch.selectDisp === false"
                @click="graphSwitch.selectDisp = true"
                >{{ btn.zoomin }}</v-btn
              >
              <v-btn
                depressed
                x-small
                color="orange"
                width="50px"
                dark
                :outlined="!graphSwitch.isLegendDisp"
                @click="graphSwitch.isLegendDisp = !graphSwitch.isLegendDisp"
                class="ml-1 mr-1"
              >
                <v-icon small>import_contacts</v-icon>
                {{ btn.legend }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]水質 グラフダイアログ
 * TmWtrQualGraphDlg.vue
 * @author LIS
 */

import TmWtrQualGraph from "./TmWtrQualGraph.vue";

export default {
  name: "tm-wtrQual-graph-dlg",
  components: {
    TmWtrQualGraph,
  },
  props: {
    /** 左軸表示グラフ番号表示 */
    left: {
      type: Number,
      default: 0,
    },
    /** 右表示グラフ番号表示 */
    right: {
      type: Number,
      default: 0,
    },
    /** 拡大/全体指定 */
    isExpansion: {
      type: Boolean,
      default: true,
    },
    /** 凡例表示 */
    isLegend: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "水質グラフ",
        leftGraph: "左軸",
        rightGraph: "右軸",
      },
      graph: [
        { name: "水温", code: 0 },
        { name: "pH", code: 1 },
        { name: "DO", code: 2 },
        { name: "導電率", code: 3 },
        { name: "濁度", code: 4 },
        { name: "ｱﾝﾓﾆｳﾑｲｵﾝ", code: 5 },
        { name: "塩分濃度", code: 6 },
        { name: "COD", code: 7 },
      ],
      btn: {
        zoomout: "全体",
        zoomin: "拡大",
        legend: "凡例",
      },
      width: 550,
      height: 175,
      viewRight: 0,
      graphSwitch: {
        selectDisp: true,
        isLegendDisp: false,
      },
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeMount() {
    this.graphSwitch.selectDisp = this.isExpansion;
    this.graphSwitch.isLegendDisp = this.isLegend;
    this.viewLeft = this.left;
    this.viewRight = this.right;

    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    viewLeft: {
      get() {
        return this.$store.state.Telemeter.latestObsIdx;
      },
      set(val) {
        this.$store.commit("Telemeter/setLatestObsIdx", val);
      },
    },
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.graphBox !== undefined) {
          const offsetWidth = this.$refs.graphBox.offsetWidth;
          const offsetHeight = this.$refs.graphBox.offsetHeight;
          if (offsetWidth > 0 && offsetHeight > 0) {
            this.width = offsetWidth - 32;
            this.height = offsetHeight - 172;
          }
        }
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
